export const portalPaths = {
  today: "/",
  records: "/records/",
  roster: "/roster/",
  overtime: "/overtime/",
  absences: "/absences/",
  tasks: "/tasks/",
  notifications: "/notifications/",
  pinScreen: "/pin/",
  manageTasks: "/manage-tasks/",
  users: "/users/",
  profile: "/me/",
  team: "/team/",
  employee: "/team/employee/:userId/",
  setup: "/setup/",
  rota: "/rota/",
};

export const employeeUrl = (userId: string) => `/team/employee/${encodeURIComponent(userId)}/`;
